export const mdFormat = 'YYYY-MM-DD';

export const GetEmptyOffAirCost = (campaignId, startDate, endDate, billingDate, commissionRate) => {
    return {
        id: window.emptyGuid,
        campaignId: campaignId,
        offairTypeId: window.emptyGuid,
        offairTypeName: '',
        stationId: window.emptyGuid,
        stationName: 'Not billed to any station',
        price: null,
        cost: '0',
        billingDate: billingDate,
        startDate: startDate,
        endDate: endDate,
        description: '',
        status: 'Draft',
        orderNumber: '',
        quote: false,
        proDataDays: false,
        proRateMonthly: true,
        commission: commissionRate
    };
};

export const GetTotals = (oaCosts) => {
    const arr = [0, 0];
    oaCosts?.forEach((oa, i) => {
        if (oa.price && !isNaN(oa.price)) {
            arr[0] += parseFloat(oa.price);
        }
        if (oa.cost && !isNaN(oa.cost)) {
            arr[1] += parseFloat(oa.cost);
        }
    });
    return arr;
};

// ToDo: To be removed. formatCurrency is not formatting zero atm
export const toCurrency = (num, dp = 2) => {
    return `£${(Math.round(num * 100) / 100).toFixed(dp)}`;
};

export const offAirCostsInputState = (campaign) => {
    const state = { stepCompleted: true, stepEdited: false };

    if (campaign?.offairActivities?.length === 0) {
        state.stepCompleted = false;
    } else {
        state.stepEdited = true;
    }

    // ToDo: add any further checks required

    return state;
};

export const GetOffAirCostForBackend = async (oc) => {
    var result = [];
    if (oc.stationIds?.length > 0) {
        oc.stationIds?.forEach((stationId) => {
            result.push({
                id: oc.id,
                campaignId: oc.campaignId,
                offairTypeId: oc.offairTypeId,
                stationId: stationId,
                price: oc.price,
                cost: oc.cost,
                vat: oc.vat,
                commission: oc.commission,
                billingDate: oc.billingDate,
                startDate: oc.startDate,
                endDate: oc.endDate,
                description: oc.description,
                proDataDays: oc.proDataDays,
                proRateMonthly: oc.proRateMonthly
            });
        });
    } else {
        result.push({
            id: oc.id,
            campaignId: oc.campaignId,
            offairTypeId: oc.offairTypeId,
            stationId: oc.stationId,
            price: oc.price,
            cost: oc.cost,
            vat: oc.vat,
            commission: oc.commission,
            billingDate: oc.billingDate,
            startDate: oc.startDate,
            endDate: oc.endDate,
            description: oc.description,
            proDataDays: oc.proDataDays,
            proRateMonthly: oc.proRateMonthly
        });
    }

    return result;
};
